import yup from '../../../config/yup';

export const logReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('logReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    scroll: yup.boolean(),
    tenantKey: yup.string().transform((value) => value?.trim()),
    environmentKey: yup.string().transform((value) => value?.trim()),
    workspaceKey: yup.string().transform((value) => value?.trim()),
    triggerType: yup.string().transform((value) => value?.trim()),
    createdDate: yup.string().transform((value) => value?.trim()),
    recipeName: yup.string().transform((value) => value?.trim()),
    category: yup.string().transform((value) => value?.trim()),
    fromCreatedDate: yup.string().transform((value) => value?.trim()),
    toCreatedDate: yup.string().transform((value) => value?.trim()),
  }),
});
